
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 70 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M61.508 32.736v-.226H17.583l1.174-4.923h45.858l-3.107 5.15zm-2.57 4.26H16.511l.659-2.765h43.435l-1.669 2.765zm-53.141 0c.01-.927.07-1.846.153-2.765h9.452l-.66 2.765H5.798zm5.591-15.374h7.022L15.813 32.51H6.148a35.587 35.587 0 013.396-10.888h1.844zm4.861-4.44h3.49v2.72h-5.217l1.727-2.72zm2.422-4.03h11.281l3.79 2.234H18.671V13.15zm1.883-5.43h3.058l2.662 3.708h-4.97l-.75-3.709zm21.516 12.18H21.46v-2.72h20.61v2.72zm7.642-2.72v2.72h-5.921v-2.72h5.921zm-8.381 4.44h5.921v4.244h-5.921v-4.244zm-7.644 4.243h5.923v-4.243h-5.923v4.243zm-7.642 0h5.92v-4.243h-5.92v4.243zm-4.585-4.243h2.863v4.244H19.17l1.012-4.244h1.28zm33.436 0v4.244h-5.923v-4.244h5.923zm11.993 4.681a.857.857 0 00-.75-.437h-9.522v-4.244h3.963a.861.861 0 000-1.72h-9.146v-2.72h3.59a.861.861 0 000-1.72H37.26l-6.838-4.032h-2.028L24.494 6H18.45l1.098 5.43H16.95v4.031h-1.646l-2.821 4.44H3.861a.861.861 0 000 1.721h3.788c-2.363 5.029-3.576 10.321-3.576 15.754v1.341h55.351c.3 0 .58-.158.737-.415l6.716-11.131a.862.862 0 00.012-.868z","fill-rule":"evenodd"}})])
          )
        }
      }
    